// window.axios = require("axios");
// window.fuse = require('fuse.js');
import Vue from "vue";

import { docReady } from "./modules/utilities";
import NewsLetter from "./components/NewsLetter.vue";
import ContestSignUp from "./components/ContestSignUp.vue";
// import hljs from 'highlight.js/lib/highlight';

// Syntax highlighting
// hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
// hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
// hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
// hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
// hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
// hljs.registerLanguage('markdown', require('highlight.js/lib/languages/markdown'));
// hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
// hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
// hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));

// document.querySelectorAll('pre code').forEach((block) => {
//     hljs.highlightBlock(block);
// });

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  components: {
    NewsLetter,
    ContestSignUp
  },
  data: () => ({
    open: false,
    yearly: false
  })
});

class App {
  constructor() {
    this.addListeners();
    this.addIntitialisers();
  }

  addListeners() {
    let timeout;
    let scrollPos = window.scrollY;
    const header = document.querySelector(".js-header");
    const nav = document.querySelector(".js-nav");
    const navToggle = document.querySelector(".js-nav-toggle");
    const stuck = "is-sticky";
    const open = "is-open";

    window.addEventListener("scroll", () => {
      scrollPos = window.scrollY;
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null;
          if (scrollPos > 15) {
            header.classList.add(stuck);
          } else {
            header.classList.remove(stuck);
          }
        }, 30);
      }
    });

    // Navigation Toggle
    navToggle.addEventListener("click", () => {
      header.classList.toggle(open);
      nav.classList.toggle("hidden");
      navToggle.classList.toggle("is-active");
    });
  }

  addIntitialisers() {}
}

docReady(() => {
  const app = new App();
});
